import React from 'react'
import { maskValue } from '../../../util/mask'
import Title from '../../../components/ui/Title'
import { InputPrice } from '../../../components/ui/Input'
import { Select } from '../../../components/ui/Select'
import { Button } from '../../../components/ui/Button'

export const LoanSimulator = ({
    setLoanSelected,
    loans = [],
    solicitationValue,
    setSolicitationValue,
    installments,
    setInstallments,
    onSendSimulation,
    income,
    setIncome
}) => {
    return (
        <React.Fragment>
            <Title
                text1="SIMULAR"
                text2="EMPRÉSTIMO"
            />

            {loans.length === 0 && <div>
                <InputPrice
                    label={'Qual é o valor da sua renda?'}
                    prefix={'R$'}
                    value={income}
                    onChangeValue={value => setIncome(value)}
                />
                <InputPrice
                    label={'Qual é o valor desejado?'}
                    prefix={'R$'}
                    value={solicitationValue}
                    onChangeValue={value => setSolicitationValue(value)}
                />
                <Select
                    variant='rounded'
                    label='Selecione o número de parcelas'
                    value={installments}
                    onChange={e => setInstallments(e.target.value)}
                >
                    <option value="12">12x</option>
                    <option value="18">18x</option>
                    <option value="24">24x</option>
                    <option value="36">36x</option>
                    <option value="48">48x</option>
                    <option value="60">60x</option>
                    <option value="72">72x</option>
                    <option value="84">84x</option>
                    <option value="96">96x</option>
                </Select>
                <div className="flex items-center justify-end">
                    <Button onClick={onSendSimulation} className='mt-2'>Simular</Button>
                </div>
            </div>}

            {loans.length > 0 &&
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
                    {loans.map((loan, count) => {
                        return (
                            <React.Fragment>
                                <div className="w-full max-w-md bg-white rounded-2xl shadow-lg p-6 space-y-6">
                                    {/* Header */}
                                    <div className="text-center text-[#462A71] font-bold text-lg">
                                        SIMULAÇÃO {count + 1} de {loans.length} <small className="text-xs text-gray-300">({loan.codigoCoeficiente})</small>
                                    </div>

                                    {/* Dados do contrato */}
                                    <div className="bg-gray-50 rounded-xl p-4 space-y-2">
                                        <div className="text-gray-700 font-semibold">Informativo</div>
                                        <div className="flex justify-between text-sm">
                                            <span className="text-gray-600">Valor da parcela</span>
                                            <span className="text-gray-600 font-semibold">{maskValue(loan.valorParcela)}</span>
                                        </div>
                                        <div className="flex justify-between text-sm">
                                            <span className="text-gray-600">Valor a receber</span>
                                            <span className="font-semibold text-[#FA6300]">{maskValue(loan.valorLiquido)}</span>
                                        </div>
                                        {/* <div className="text-gray-500 text-sm">Data Vencimento Da Primeira Parcela {maskDateTime(loan.dataPrimeiroVencimento)}</div> */}
                                    </div>

                                    {/* Portabilidade + Troco */}
                                    <div className="bg-gray-50 rounded-xl p-4 space-y-4">
                                        <div className="flex justify-between items-center">
                                            <div className="font-semibold text-gray-700">Detalhes</div>
                                        </div>
                                        <div className="space-y-3 text-sm">
                                            <div className="flex justify-between items-center">
                                                <span className="text-gray-600">Parcelas a pagar</span>
                                                <div className="flex items-center gap-2">
                                                    <span className="text-gray-500">{loan.parcelas} meses</span>
                                                </div>
                                            </div>
                                            <div className="flex justify-between items-center">
                                                <span className="text-gray-600">Taxa a.m.</span>
                                                <div className="flex items-center gap-2">
                                                    <span className="text-gray-500">{loan.taxa}%</span>
                                                </div>
                                            </div>
                                            <div className="flex justify-between items-center">
                                                <span className="text-gray-600">Taxa a.a.</span>
                                                <div className="flex items-center gap-2">
                                                    <span className="text-gray-500">{loan.taxaAnual}%</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Botão */}
                                    <button onClick={() => setLoanSelected(loan)} className="w-full bg-[#FA6300] text-white font-semibold py-3 rounded-full">
                                        Iniciar contratação
                                    </button>
                                </div>
                            </React.Fragment>
                        )
                    })}
                </div>
            }
        </React.Fragment >
    )
}